function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useMemo } from "react";
import { Pressable, ScrollView } from "react-native";
import { useBiblo } from "../../hooks/Biblo.hook";
import { Typography, TypographySize } from "../Typography.component";
import { getViewStyles } from "../../helpers/getStyles.helper";
export const IndexHeaderTags = () => {
  const {
    files,
    indexOptions,
    enabledTags,
    setEnabledTags,
    defaultStyles,
    disableDefaultStyles: disableDefaultStylesGlobal
  } = useBiblo();
  const disableDefaultStyles = disableDefaultStylesGlobal || indexOptions.disableDefaultStyles;
  const tags = useMemo(() => [...new Set(files.map(file => file.data.map(_ref => {
    let {
      tags
    } = _ref;
    return tags;
  })).flat(2))].sort().filter(tag => typeof tag === "string").map(tag => ({
    tag: tag,
    enabled: enabledTags.includes(tag)
  })), [files, enabledTags]);
  const enableTag = useCallback(function (tag) {
    let multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return setEnabledTags(current => multiple ? [...current, tag] : [tag]);
  }, [setEnabledTags]);
  const disableTag = useCallback(tag => setEnabledTags(current => [...current].filter(value => value !== tag)), [setEnabledTags]);
  const Tags = useMemo(() => indexOptions.headerTagsComponent || (_ref2 => {
    let {
      style,
      ...props
    } = _ref2;
    return /*#__PURE__*/React.createElement(ScrollView, _extends({
      horizontal: true,
      showsHorizontalScrollIndicator: false,
      contentContainerStyle: style
    }, props));
  }), [indexOptions.headerTagsComponent]);
  return /*#__PURE__*/React.createElement(Tags, {
    tags: tags,
    enabledTags: enabledTags,
    style: getViewStyles(indexOptions.headerTagsStyle, {
      marginTop: defaultStyles.spacing,
      paddingHorizontal: defaultStyles.spacing
    }, disableDefaultStyles),
    itemStyle: indexOptions.headerTagsItemStyle,
    itemTextStyle: indexOptions.headerTagsItemTextStyle,
    enableTag: enableTag,
    disableTag: disableTag,
    resetTags: () => setEnabledTags([])
  }, tags.map((_ref3, index) => {
    let {
      tag,
      enabled
    } = _ref3;
    return tag ? /*#__PURE__*/React.createElement(Pressable, {
      key: tag,
      onPress: () => enabled ? disableTag(tag) : enableTag(tag),
      onLongPress: () => enabled ? disableTag(tag) : enableTag(tag, true),
      style: getViewStyles(indexOptions.headerTagsItemStyle, {
        marginLeft: index ? 5 : 0,
        height: 40,
        paddingHorizontal: 9,
        justifyContent: "center",
        borderWidth: 1,
        borderColor: defaultStyles.surfaceColor,
        backgroundColor: enabled ? undefined : defaultStyles.surfaceColor
      }, disableDefaultStyles)
    }, /*#__PURE__*/React.createElement(Typography, {
      size: TypographySize.Small,
      disableDefaultStyles: disableDefaultStyles,
      style: indexOptions.headerTagsItemTextStyle
    }, tag)) : null;
  }));
};
//# sourceMappingURL=IndexHeaderTags.component.js.map